import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { brands } from '../data/brands';
import { brandServiceKeywords } from '../data/brandServiceKeywords';
import BrandServiceList from '../components/brands/BrandServiceList';
import ContactCTA from '../components/shared/ContactCTA';

export default function BrandService() {
  const { brand: brandId } = useParams();
  const brand = brands.find(b => b.id === brandId);
  const brandKeywords = brandServiceKeywords[brandId || ''] || {};

  if (!brand) {
    return <Navigate to="/brands" replace />;
  }

  // Generate meta description with keywords
  const keywordsList = Object.values(brandKeywords)
    .flat()
    .slice(0, 10)
    .join(', ');

  return (
    <>
      <Helmet>
        <title>{`${brand.name} Appliance Repair Services | Parakh Services`}</title>
        <meta 
          name="description" 
          content={`Professional repair services for ${brand.name} appliances including ${keywordsList}. Expert technicians and same-day service with warranty.`} 
        />
      </Helmet>
      
      <div className="bg-blue-600 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-extrabold text-white mb-4">
            {brand.name} Service Center
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Professional repair services for all {brand.name} appliances with expert technicians and 90-day warranty
          </p>
          
          {/* Keywords Overview */}
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {Object.values(brandKeywords)
              .flat()
              .slice(0, 8)
              .map((keyword, index) => (
                <span 
                  key={index}
                  className="px-3 py-1 bg-white/10 text-white rounded-full text-sm"
                >
                  {keyword}
                </span>
              ))}
          </div>
        </div>
      </div>
      
      <BrandServiceList brand={brand} />
      <ContactCTA />
    </>
  );
}